interface Position {
  latitude: number;
  longitude: number;
}
const { startTime, endTime } = useTimer();
const successHandler = (resolve: (position: Position) => void) => {
  return (position: GeolocationPosition) => {
    const { latitude, longitude } = position.coords;
    console.log("获取位置成功：", { latitude, longitude });

    endTime("从浏览器获取经纬度时间");
    resolve({ latitude, longitude });
  };
};
const errorHandler = (reject: (error: GeolocationPositionError) => void) => {
  return (error: GeolocationPositionError) => {
    console.log("获取位置失败：" + error.message);
    endTime("从浏览器获取经纬度时间");
    reject(error);
  };
};
const options = {
  // 高级选项，例如设置获取位置的精度
  enableHighAccuracy: true,
  // 与 Geolocation 规范一致：此处为浏览器层超时；过短会在用户尚未点「允许」时就结束请求。
  // react-geolocated 默认 Infinity；其 userDecisionTimeout 只改 UI，不会取消底层 getCurrentPosition。
  // timeout: Infinity,
  // timeout: 1000 * 10,
  timeout: 1000 * 10 * 3, // 30秒
  // timeout: 1000 * 10 * 6, // 60秒
  // 最长有效期，在这个时间后，即使位置信息还是有效的，也会重新获取一次，单位为毫秒
  maximumAge: 0, // 最大缓存时间为0毫秒，即不使用缓存位置
};

export const getCurrGeo = (): Promise<Position> => {
  console.log("开始从浏览器获取经纬度");
  startTime();
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(successHandler(resolve), errorHandler(reject), options);
    } else {
      console.log("浏览器不支持Geolocation API");
      reject(new Error("浏览器不支持Geolocation API"));
    }
  });
};
